<template>
    <b-row>
        <b-col cols="12">
            <search-view :click-search="getInstallations"/>
        </b-col>

        <b-col cols="12">
            <b-card title="">
                <b-overlay
                    variant="white"
                    :show="showLoading"
                    spinner-variant="primary"
                    blur="0"
                    opacity=".75"
                    rounded="sm"
                >
                    <div class="ml-1 mb-2">
                        <b-row>
                            <b-col cols="12" md="9"
                                   class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                            >
                                <label>Mostrar</label>
                                <v-select
                                    v-model="pageLength"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    :options="['3','5','10','20']"
                                    :clearable="false"
                                    class="per-page-selector d-inline-block mx-50"
                                    @input="changeLength"
                                />
                                <b-button v-if="can('create_vhe_master')" variant="primary" @click="goToCreate()">
                                    Añadir nueva Instalación VHE
                                </b-button>
                                <b-button
                                    v-if="selectedIds.length"
                                    variant="outline-primary"
                                    class="ml-1"
                                    @click="openDownloadSummary()"
                                >
                                    Descargar documentación ({{ selectedIds.length }})
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <b-table
                        ref="refUserListTable"
                        class="position-relative table-size-list"
                        :items="masters_installations"
                        responsive
                        striped
                        sticky-header
                        :fields="columns"
                        primary-key="id"
                        show-empty
                        empty-text="No hay registros"
                        :tbody-tr-class="rowClass"
                        @row-clicked="handleRowClick"
                    >
                        <template #head(select)>
                            <div @click.stop>
                                <b-form-checkbox
                                    :checked="allSelected"
                                    :indeterminate="someSelected"
                                    @change="toggleSelectAll"
                                />
                            </div>
                        </template>

                        <template #cell(select)="data">
                            <div
                                class="select-cell-inner d-flex align-items-center justify-content-center"
                                @click.stop
                                @mousedown.stop
                            >
                                <b-form-checkbox
                                    :checked="selectedIds.includes(data.item.id)"
                                    @change="toggleSelect(data.item.id)"
                                />
                            </div>
                        </template>

                        <template #cell(name)="data">
                            <router-link :to="{ name: 'users_edit', params: { id: data.item.id} }">
                                {{ data.item.name }}
                            </router-link>
                        </template>

                        <template #cell(date_start)="data">
                            {{ data.item.start_date ? helpers.formatDate(data.item.start_date) : null }}
                        </template>

                        <template #cell(date_end)="data">
                            {{ data.item.end_date ? helpers.formatDate(data.item.end_date) : null }}
                        </template>

                        <template #cell(active)="data">
                            <b-badge :variant="data.value === 1 ? 'success' : 'danger'">
                                {{ data.value === 1 ? 'Si' : 'No' }}
                            </b-badge>
                        </template>

                        <template #cell(serial_numbers)="data">
                            <b-badge v-for="activity in data.item.serial_numbers" :key="activity.id" class="mr-1" variant="primary">
                                {{ activity.serial_number }}
                            </b-badge>
                        </template>


                        <template #cell(actions)="data" class="col-sm-2">
                          <div @click.stop>
                            <router-link :to="{ name: 'installations_vhe_edit', params: { id: data.item.id} }">
                                <feather-icon
                                    v-if="can('Dashboard')"
                                    :id="`invoice-row-${data.item.id}-send-icon`"
                                    icon="EditIcon"
                                    class="cursor-pointer"
                                    size="16"
                                />

                            </router-link>

                            <feather-icon
                                v-if="can('delete_vhe_master')"
                                :id="`invoice-row-${data.item.id}-preview-icon`"
                                icon="TrashIcon"
                                size="16"
                                class="cursor-pointer ml-1 text-red"
                                @click="deleteMasterInstallation(data.item.id)"
                            />
                            <b-tooltip
                                title="Eliminar Instalación"
                                :target="`invoice-row-${data.item.id}-preview-icon`"
                            />
                          </div>
                        </template>
                    </b-table>

                    <div class="mx-2 mb-2">
                        <b-row>
                            <b-col
                                cols="12"
                                sm="6"
                                class="d-flex align-items-center justify-content-center justify-content-sm-start"
                            >
                                <span class="text-muted">Mostrando {{ pageLength }} de {{ totalRecords }} Instalaciones</span>
                            </b-col>

                            <b-col
                                cols="12"
                                sm="6"
                                class="d-flex align-items-center justify-content-center justify-content-sm-end"
                            >
                                <b-pagination
                                    :value="1"
                                    :total-rows="totalRecords"
                                    :per-page="pageLength"
                                    first-number
                                    last-number
                                    align="right"
                                    prev-class="prev-item"
                                    next-class="next-item"
                                    class="mt-1 mb-0"
                                    @input="changePage"
                                >
                                    <template #prev-text>
                                        <feather-icon
                                            icon="ChevronLeftIcon"
                                            size="18"
                                        />
                                    </template>
                                    <template #next-text>
                                        <feather-icon
                                            icon="ChevronRightIcon"
                                            size="18"
                                        />
                                    </template>
                                </b-pagination>
                            </b-col>
                        </b-row>
                    </div>
                </b-overlay>
            </b-card>

            <b-modal
                v-model="showSummaryModal"
                title="Resumen de descarga de documentación"
                size="lg"
                centered
                scrollable
                no-close-on-backdrop
                cancel-title="Cancelar"
                cancel-variant="outline-secondary"
                ok-title="Confirmar descarga"
                ok-variant="primary"
                :ok-disabled="downloadableCount === 0 || downloading"
                @ok.prevent="confirmDownload"
            >
                <div v-if="checkingAvailability" class="text-center py-3">
                    <b-spinner variant="primary" />
                    <p class="mt-2 mb-0">Comprobando documentación…</p>
                </div>

                <div v-else>
                    <p class="mb-2">
                        Has seleccionado <strong>{{ availability.length }}</strong>
                        {{ availability.length === 1 ? 'instalación' : 'instalaciones' }}.
                    </p>

                    <div v-if="withDocuments.length" class="mb-2">
                        <div class="d-flex align-items-center mb-1 text-success font-weight-bold">
                            <feather-icon icon="CheckCircleIcon" size="18" class="mr-50" />
                            Se descargará la documentación de {{ withDocuments.length }}
                            {{ withDocuments.length === 1 ? 'instalación' : 'instalaciones' }}
                        </div>
                        <b-list-group>
                            <b-list-group-item
                                v-for="item in withDocuments"
                                :key="`with-${item.id}`"
                                class="d-flex align-items-center py-50"
                            >
                                <feather-icon icon="FileTextIcon" size="16" class="mr-75 text-success" />
                                {{ item.installation_code }}
                            </b-list-group-item>
                        </b-list-group>
                    </div>

                    <div v-if="withoutDocuments.length">
                        <div class="d-flex align-items-center mb-1 text-warning font-weight-bold">
                            <feather-icon icon="AlertTriangleIcon" size="18" class="mr-50" />
                            {{ withoutDocuments.length }}
                            {{ withoutDocuments.length === 1 ? 'instalación no tiene' : 'instalaciones no tienen' }}
                            documentación (no se incluirán)
                        </div>
                        <b-list-group>
                            <b-list-group-item
                                v-for="item in withoutDocuments"
                                :key="`without-${item.id}`"
                                class="d-flex align-items-center py-50 text-muted"
                            >
                                <feather-icon icon="SlashIcon" size="16" class="mr-75 text-warning" />
                                {{ item.installation_code }}
                            </b-list-group-item>
                        </b-list-group>
                    </div>

                    <b-alert v-if="downloadableCount === 0" variant="warning" show class="mt-2 mb-0">
                        <div class="alert-body">
                            Ninguna de las instalaciones seleccionadas tiene documentación para descargar.
                        </div>
                    </b-alert>
                </div>
            </b-modal>
        </b-col>
    </b-row>
</template>

<script>
import {BRow, BCol, BTable, BCard, BButton, BTooltip, BPagination, BOverlay, BBadge, BFormCheckbox, BModal, BListGroup, BListGroupItem, BSpinner, BAlert} from 'bootstrap-vue'
import vSelect from "vue-select"
import {mapState} from "vuex"
import Swal from "sweetalert2"
import {VHE_MASTERS_INSTALLATIONS_CREATE} from "@/router/web/constants"
import helpers from "@/resources/helpers/helpers"
import SearchView from "@/views/vhe/masters_installations/list/components/searchView"
import helper from "@/resources/helpers/helpers"

export default {
    name: "ListView",
    components: {
        BRow,
        BCol,
        BTable,
        BCard,
        BButton,
        BTooltip,
        BPagination,
        BOverlay,
        BBadge,
        BFormCheckbox,
        BModal,
        BListGroup,
        BListGroupItem,
        BSpinner,
        BAlert,

        vSelect,
        SearchView
    },
    data() {
        return {
            page: 1,
            pageLength: 10,
            totalRecords: 10,
            selectedIds: [],
            columns: [
                {key: 'select', label: '', sortable: false, tdClass: 'select-cell'},
                {key: 'actions', label: 'Acciones', sortable: false},
                {key: 'installation_code', label: 'Nombre', sortable: false},
                {key: 'client', label: 'Cliente', sortable: false},
                {key: 'date_start', label: 'Fecha inicio explotación', sortable: false},
                {key: 'date_end', label: 'Fecha fin explotación', sortable: false},
                {key: 'or_number', label: 'OR', sortable: false},
                {key: 'active', label: 'Activa', sortable: false},
            ],
            searchTerm: '',
            showLoading: false,
            showSummaryModal: false,
            checkingAvailability: false,
            downloading: false,
            availability: [],
            helpers
        }
    },
    computed: {
        ...mapState('masterInstallationVhe', ['masters_installations', 'search']),
        allSelected() {
            return this.masters_installations.length > 0
                && this.masters_installations.every(item => this.selectedIds.includes(item.id))
        },
        someSelected() {
            return this.selectedIds.length > 0 && !this.allSelected
        },
        withDocuments() {
            return this.availability.filter(item => item.has_documents)
        },
        withoutDocuments() {
            return this.availability.filter(item => !item.has_documents)
        },
        downloadableCount() {
            return this.withDocuments.length
        },
    },
    created() {
        // Other views load every installation into this same state key; rendering that before our page arrives freezes the table for seconds.
        this.$store.commit('masterInstallationVhe/SET_MASTERS_INSTALLATIONS', [])
        this.getInstallations()
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        formatDate(date) {
            const dateFormated = new Date(date)

            return dateFormated.toLocaleDateString("es-ES")
        },
        getInstallations() {
            this.showLoading = true

            this.$store.dispatch('masterInstallationVhe/searchMasterInstallations', {
                per_page: this.pageLength,
                page: this.page,
                filter: this.search,
            })
                .then(response => {
                    this.showLoading = false
                    this.totalRecords = response.total_records
                })
                .catch(error => {
                    this.showLoading = false
                    console.log(error)
                })
        },
        deleteMasterInstallation(id) {
            Swal.fire({
                title: "Estás seguro que quieres eliminar la instalación?",
                text: "Una vez borrada no se podra recuperar!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "¡Sí, borralo!",
                cancelButtonText: "Cancelar",
            }).then(result => {
                if (result.value) {
                    this.$store.dispatch('masterInstallationVhe/deleteMasterInstallation', {id: id})
                        .then(response => {
                            this.showLoading = false
                            helper.showToast('Instalación eliminada correctamente!', 'CheckIcon', 'success')
                            this.getInstallations()
                        })
                        .catch(error => {
                            this.showLoading = false
                            helper.showToast('Error al eliminar la instalación', 'AlertOctagonIcon', 'danger')
                            console.log(error)
                        })
                }
            })
        },
        changePage(page) {
            this.page = page
            this.getInstallations()
        },
        changeLength(length) {
            this.length = length
            this.getInstallations()
        },
        searchUser() {
            this.getInstallations()
        },
        goToCreate(){
            this.$router.push(VHE_MASTERS_INSTALLATIONS_CREATE)
        },
        handleRowClick(data) {
          this.$router.push({name: 'installations_vhe_edit', params: {id: data.id}})
        },
        rowClass(item) {
          return item ? 'cursor-pointer' : ''
        },
        toggleSelect(id) {
            const index = this.selectedIds.indexOf(id)
            if (index === -1) {
                this.selectedIds.push(id)
            } else {
                this.selectedIds.splice(index, 1)
            }
        },
        toggleSelectAll(checked) {
            if (checked) {
                const pageIds = this.masters_installations.map(item => item.id)
                this.selectedIds = [...new Set([...this.selectedIds, ...pageIds])]
            } else {
                const pageIds = this.masters_installations.map(item => item.id)
                this.selectedIds = this.selectedIds.filter(id => !pageIds.includes(id))
            }
        },
        openDownloadSummary() {
            this.availability = []
            this.checkingAvailability = true
            this.showSummaryModal = true

            this.$store.dispatch('masterInstallationVhe/checkInstallationsDocuments', {ids: this.selectedIds})
                .then(result => {
                    this.availability = result
                    this.checkingAvailability = false
                })
                .catch(error => {
                    this.checkingAvailability = false
                    this.showSummaryModal = false
                    helper.showToast(error.message, 'AlertOctagonIcon', 'danger')
                })
        },
        confirmDownload() {
            const ids = this.withDocuments.map(item => item.id)

            if (!ids.length) {
                return
            }

            this.downloading = true
            this.$store.dispatch('masterInstallationVhe/downloadInstallationsDocuments', {ids})
                .then(() => {
                    this.downloading = false
                    this.showSummaryModal = false
                    helper.showToast('Documentación descargada correctamente!', 'CheckIcon', 'success')
                })
                .catch(error => {
                    this.downloading = false
                    this.showSummaryModal = false
                    helper.showToast(error.message, 'AlertOctagonIcon', 'danger')
                })
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

// La celda de selección no lleva padding: el div interior ocupa toda la celda
// y captura/frena el clic para que no se propague a la fila (que navega a la instalación).
.select-cell {
    padding: 0 !important;

    .select-cell-inner {
        width: 100%;
        height: 100%;
        min-height: 2.5rem;
        padding: 0 0.72rem;
        cursor: default;
    }

    .custom-control {
        margin-right: 0;
    }
}
</style>